module.exports = __webpack_public_path__ + "media/assets/images/flags/lv-f15b71404277631844f5749f418bac4e.svg";